export default __webpack_public_path__ + "assets/webgl/complete-2.e3c9ce50.jpg";